export const ADMIN_MODULES = ['EMPLOYEES', 'POLLS'] as const;

export type AdminModuleName = (typeof ADMIN_MODULES)[number];

export function resolveAdminModules(
  role?: string | null,
  stored?: AdminModuleName[] | null,
): AdminModuleName[] {
  if (role !== 'ADMIN') return [];
  const modules = (stored ?? []).filter(
    (value): value is AdminModuleName => value === 'EMPLOYEES' || value === 'POLLS',
  );
  if (modules.length === 0) return ['EMPLOYEES'];
  return [...new Set(modules)];
}

export function hasAdminModule(
  role?: string | null,
  stored?: AdminModuleName[] | null,
  module: AdminModuleName = 'EMPLOYEES',
): boolean {
  return resolveAdminModules(role, stored).includes(module);
}
